import React from "react";
import { setHeader } from "@/util/set-header";
import { Icon,Toast, List } from "antd-mobile";
import './change-park.less'
import { withRouter } from "react-router";
import { StoreCityListApi, ReserveStoreListApi } from "@/api/sany";

const ListItem = List.Item

@(withRouter as any)
export default class ChangePark extends React.Component<any,any> {
  state = {
    cityId: '',
    cityName: '',
    content: '',
    cityIndex: '0',
    parkIndex: '0',
    showSearchList: false,
    cityList: [],
    parkList: [],
    searchParkList: []
  }
  bodyH = document.documentElement.clientHeight - 85
  fetchStoreList: any
  constructor(props: any) {
    super(props)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.fetchStoreList = this.debounce(this.gitStoreList.bind(this))
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  rightBtn() {
    return (
      <div style={{ display: 'flex', fontSize: '12px' }} onClick={() => this.locationReload()}>
        <div style={{ marginRight: '5px' }}  >{this.state.cityName}</div>
        {/* <div><Icon type="down" /></div> */}
        <div className="reload-icon" id="reload-icon">
          <img src="../../../public/assets/img/reload.png" alt="" width='15px' height='15px'/>
        </div>
      </div>
    )
  }

  locationReload() {
    const reloadIcon: any =  document.getElementById('reload-icon')
    console.log('animation state', reloadIcon.style.webkitAnimationPlayState)
    if (reloadIcon.style.webkitAnimationPlayState == "paused"){
      reloadIcon.style.webkitAnimationPlayState = "running";
    }
    this.getMap()
  }

  componentDidMount() {
    setHeader({ title: '选择园区', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightBtn() })
    this.getMap()
    this.fetchCityList()
    window.onload = () => {
      const htmlCollection: any = document.getElementsByTagName("iframe")
      var arr = Array.prototype.slice.call( htmlCollection )
      arr.forEach(ele => {
        ele.remove()
      })
    }
  }

  async fetchCityList() {
    const {data} = await StoreCityListApi({})
    if (data.code === 'SUCCESS') {
      this.setState({
        cityList: data.data
      })
      if (data.data.length > 0) {
        const item = data.data[0]
        this.setState({
          cityIndex: item.id
        })
        this.gitStoreList(item.id)
      }
      this.locationInCityList(this.state.cityName)
    }
  }

  // 根据关键词获取园区名称
  gitStoreList(regionId: string = '') {
    console.log('search', this.state.content)
    let name = this.state.content
    let parmas: any
    if (regionId.length === 0) {
      parmas = { store_name: name }
    } else {
      parmas = {region_id: regionId, store_name:name}
    }
    ReserveStoreListApi(parmas).then((res:any)=>{
      if (res.data.code === 'SUCCESS') {
        if (regionId === '') {
          this.setState({
            searchParkList: res.data.data
          })
        } else {
          this.setState({
            parkList: res.data.data
          })
        }
      } else {
        Toast.info(res.data.msg)
      }
    })
  }

  componentDidUpdate() {
    if (this.state.cityName.length > 0) {
      const htmlCollection: any = document.getElementsByTagName("iframe")
      var arr = Array.prototype.slice.call( htmlCollection )
      arr.forEach(ele => {
        ele.remove()
      })
    }
  }

  getMap() {
    console.log('getmap')
    const _this=this;
    var BMap = window.BMap
    var geoc = new BMap.Geocoder()
    var geolocation = new BMap.Geolocation()
     geolocation.getCurrentPosition(function (r: any) {
        geoc.getLocation(r.point, function (rs: any) {
            var addComp = rs.addressComponents
            let cityName = addComp.city
            console.log('cityName', cityName)
            _this.setState({
              cityName:cityName,  //城市名
            }, async ()=>{
              setHeader({ title: '选择园区', leftToHome: _this.goHomePage, leftClick: _this.leftClick, right: _this.rightBtn() })
              const reloadIcon: any =  document.getElementById('reload-icon')
              reloadIcon.style.webkitAnimationPlayState = "paused"
              _this.locationInCityList(cityName)
            })
        })
    })
  }

  // 对比当前位置城市和城市列表
  locationInCityList(cityName: string) {
    this.state.cityList.map((ele: any, index: number) => {
      if (cityName.includes(ele.name)) {
        this.setState({
          cityIndex: ele.id
        })
        this.gitStoreList(ele.id)
        return
      }
    })
  }

  // 选择园区
  changeStore() {
    return (
      <div className="search-body">
        <span className="search-body-input">
          <img src="/public/assets/img/search.png" alt="" />
          <input
            placeholder="请输入园区"
            onChange={({ target }: any) => this.setKey(target.value)}
            type="search"
            onKeyPress={this.onKeyPress}
          />
        </span>
      </div>
    )
  }

  // 获取输入值
  setKey(val:string) {
    this.setState({
      content:val,
      showSearchList: val.length > 0
    })
    if(val.length === 0) {
      this.setState({
        content:'',
        showSearchList: false
      },() => {
        this.gitStoreList(this.state.cityIndex)
      })
    } else {
      this.fetchStoreList()
    }
  }
  // 请求门店列表
  onKeyPress(event:any) {
    if (event.key === 'Enter') {
      // this.gitStoreList()
    }
  }

//防抖debounce代码：
debounce(fn: any, delay = 1000) {
  let timeout: any // 创建一个标记用来存放定时器的返回值
  return (event: any) => {
    let that = this
    // 每当用户输入的时候把前一个 setTimeout clear 掉
    clearTimeout(timeout); 
    // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
    timeout = setTimeout(function() {
      fn.apply(that, arguments);
    }, delay);
  }
}


  // 模糊查询列表
  parkListComponent() {
    return (
      <div className="city-park-body" style={{height: this.bodyH, overflowY: 'scroll'}}>
        {this.parkListView()}
      </div>
    )
  }

  parkListView() {
    let list = this.state.searchParkList
    return (
      <List>
        {list.map((ele: any) => <ListItem key={ele} style={{backgroundColor: ele.id === this.state.cityIndex ? 'skyblue' : 'white'}} onClick={() => this.parkListClick(ele)}>{ele.name}</ListItem>)}
      </List>
    )
  }
  
  // 城市园区联动列表
  cityAndParkComponent() {
    return (
      <div className="city-park-body" style={{height: this.bodyH}}>
        <div className="city-park-header">
          <div className="header-title">城市</div>
          <div className="header-title">园区</div>
        </div>
        <div className="city-park-content">
          <div className="city-park-list">
            {this.cityListView()}
          </div>
          <div className="city-park-list">
          {this.parkOfCityView()}
          </div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    )
  }

  cityListView() {
    let list = this.state.cityList
    return (
      <List>
        {list.map((ele: any, index: number) => <ListItem key={ele.id} style={{backgroundColor: (this.state.cityIndex === '0' && index.toString() === '0') || (ele.id === this.state.cityIndex) ? 'skyblue' : 'white'}} onClick={() => this.cityListClick(ele)}>{ele.name}</ListItem>)}
      </List>
    )    
  }

  cityListClick(ele: any) {
    this.setState({
      cityIndex: ele.id,
      parkIndex: '0'
    })
    this.gitStoreList(ele.id)
  }

  parkOfCityView() {
    let list = this.state.parkList
    return (
      <List>
        {list.map((ele: any, index: number) => <ListItem key={ele.id} style={{backgroundColor: (this.state.parkIndex === '0' && index.toString() === '0') || ele.id === this.state.parkIndex ? 'skyblue' : 'white'}} onClick={() => this.parkListClick(ele)}>{ele.name}</ListItem>)}
      </List>
    ) 
  }

  parkListClick(ele: any) {
    this.setState({
      parkIndex: ele.id
    })
    sessionStorage.setItem('sanyStoreId', ele.id)
    sessionStorage.setItem('sanyStoreName', ele.name)
    sessionStorage.setItem('sanyStoreQueue', ele.is_queue)
    this.props.history.goBack()
  }

  render() {
    return (
      <div className="change-park">
        {this.changeStore()}
        {this.state.showSearchList ? this.parkListComponent() : this.cityAndParkComponent()}
      </div>
    )
  }

}